/**
 * Id de entrega (message_deliveries.id) desde respuesta del API.
 */
export function resolveDeliveryId(message) {
    if (!message) return null;
    const raw = message.deliveryId ?? message.delivery_id;
    const id = Number(raw);
    return Number.isFinite(id) && id > 0 ? id : null;
}
